'use client';

import { useEffect, useRef } from 'react';

export const useAutoPlayVideoRef = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const observer = useRef<IntersectionObserver | null>(null);

  // handle problems of autoplaying videos on mobile
  useEffect(() => {
    const listener = () => {
      if (!videoRef.current) {
        return;
      }
      videoRef.current.muted = true;
      videoRef.current.playsInline = true;
      if (!videoRef.current.played || videoRef.current.paused) {
        videoRef.current?.play().catch(() => {
          if (videoRef.current) videoRef.current.controls = true;
        });
      }
    };

    document.addEventListener('touchstart', listener);
    document.addEventListener('click', listener);
    window.addEventListener('focus', listener);

    observer.current = new IntersectionObserver((entries) => {
      if (!videoRef.current) return;
      if (entries[0].isIntersecting) {
        videoRef.current.play().catch(() => {
          if (!videoRef.current) return;
          videoRef.current.controls = true;
        });
      } else {
        videoRef.current.pause();
      }
    }, {});

    videoRef.current && observer.current.observe(videoRef.current);

    return () => {
      document.removeEventListener('touchstart', listener);
      document.removeEventListener('click', listener);
      window.removeEventListener('focus', listener);

      if (observer.current && videoRef.current) {
        observer.current.unobserve(videoRef.current);
      }
    };
  }, []);

  return videoRef;
};
